// extracted by mini-css-extract-plugin
export var reviews = "style-module--reviews--d54c9";
export var reviews__courseName = "style-module--reviews__course-name--ead49";
export var reviews__info = "style-module--reviews__info--44ab9";
export var reviews__item = "style-module--reviews__item--138a8";
export var reviews__list = "style-module--reviews__list--69ee3";
export var reviews__name = "style-module--reviews__name--13efc";
export var reviews__result = "style-module--reviews__result--f74e6";
export var reviews__resultItem = "style-module--reviews__result-item--2ed37";
export var reviews__title = "style-module--reviews__title--4ca63";
export var reviews__video = "style-module--reviews__video--12e88";
export var swiperButtonNext = "style-module--swiper-button-next--c77af";
export var swiperButtonPrev = "style-module--swiper-button-prev--2931b";